import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FEATURE_NAME, IPolCoreState } from '../models/state.model';

export const selectCoreFeatureState = createFeatureSelector<IPolCoreState>(FEATURE_NAME);

export const getSignedInUser = createSelector(selectCoreFeatureState, (state: IPolCoreState) => {
  let user = state?.userState?.user;

  if (!user) {
    const sessionuser = JSON.parse(sessionStorage.getItem('user-profile'));
    user = {
      firstName: sessionuser?.given_name,
      lastName: sessionuser?.family_name,
      username: sessionuser?.preferred_username,
      providerType: sessionuser?.providerType?.toLowerCase(),
    };
  }

  return user;
});

export const getUserState = createSelector(selectCoreFeatureState, (state: IPolCoreState) => state?.userState);

export const getProviderState = createSelector(selectCoreFeatureState, (state: IPolCoreState) => state?.providerState);

export const getRefreshTokenUrl = createSelector(
  selectCoreFeatureState,
  (state: IPolCoreState) => state?.userState?.refreshToken
);

export const getMyOaas = createSelector(selectCoreFeatureState, (state: IPolCoreState) => state?.userState?.myOaas);

export const idleTimeoutReset = createSelector(selectCoreFeatureState, state => state?.userState?.idleTimeoutResetCount);

export const selectShouldDisableUserMenu = createSelector(selectCoreFeatureState, state => state?.userState?.shouldDisableUserMenu || false);
